
import React, { useState } from 'react';
import '../Maintenance-styles/modalSelector.css';

const SelectorGroupModal = ({ groups = [], onClose, onSelectGroup }) => {
  // Estado para almacenar el término de búsqueda
  const [searchTerm, setSearchTerm] = useState('');

  // Filtrar los grupos según el término de búsqueda
  const filteredGroups = groups.filter((group) =>
    group.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="modal">
      <button className="close-modal-button" onClick={onClose}>
        &times;
      </button>
      <h2>Seleccionar Grupo</h2>

      <input
        type="text"
        className="input search-group"
        placeholder="Buscar grupo..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)} // Actualizar el término de búsqueda
      />

      <div className="modal-select-list">
        {filteredGroups.map((group) => (
          <div
            key={group.groupid || group.name} // Aseguramos que cada grupo tenga una key única
            className="select-item"
            onClick={() => {
              onSelectGroup(group);
              onClose();
            }}
          >
            {group.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SelectorGroupModal;
